export class TOCModel {
    id: string | undefined;
    name: string | undefined;
    code: string | undefined;
}